import { Partner } from "@dashboard/common/types";
import { camelizeKeys, decamelizeKeys } from "humps";

export type ProfileApiError = Error & {
  code?: string;
  status?: number;
};

export const fetchUpdateUserDetail = async (
  token: string,
  data: Partner
): Promise<Partner> => {
  const response = await fetch(
    `${process.env.REACT_APP_BASE_URL}/api/ms/user/user-detail`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      } as { [key: string]: string },
      body: JSON.stringify(decamelizeKeys(data)),
    }
  );
  if (response.status === 200) {
    const responseJson = await response.json();
    return camelizeKeys(responseJson) as Partner;
  } else {
    let errorCode = "unknown_error";
    let errorMessage = "Unknown error";
    try {
      const responseJson = await response.json();
      errorCode =
        responseJson?.code || responseJson?.error?.code || responseJson?.error || errorCode;
      errorMessage =
        responseJson?.message || responseJson?.error?.message || errorMessage;
    } catch (_error) {
      // No-op: keep default fallback values if body is not JSON.
    }
    const error = new Error(errorMessage) as ProfileApiError;
    error.code = errorCode;
    error.status = response.status;
    throw error;
  }
};
